import { type BaseModalProps, DesktopModal } from '@byecode/ui'
import React from 'react'

import WeComAccount from './WeComEmailAccount'

interface WeComEmailAccountModalProps extends BaseModalProps {}

export const WeComEmailAccountModal: React.FunctionComponent<WeComEmailAccountModalProps> = ({ ...rest }) => {
    return (
        <DesktopModal
            width={676}
            {...rest}
            styles={{
                modal: {
                    maxHeight: 'calc(100% - 48px)'
                },
                body: {
                    padding: '0!important'
                },
                header: {
                    borderStyle: 'none'
                }
            }}
        >
            <WeComAccount onClose={rest.onClose} />
        </DesktopModal>
    )
}
